
  export const Config ={
  API_URL: 'https://api-uat.iiflonehome.com/api/',
 SOCKETENDPOINT: 'https://api-uat.iiflonehome.com',
 REDIRECTURL:'https://uat.iiflonehome.com/auction/bids',
  FBAPPID: '590323375838229',
  GOOGLECLIENTID: '632002254786-lfoejeohonsc4rgte87gl2ps6qmjouql.apps.googleusercontent.com',
  SSLPINNING: "sha256/bMu9l9+NKsH+CxaWm1dgCbrQxfSiZ/N3M6//qhA8cIE=",
  PAYMENTGATEWAYURL: 'https://smartapps-uat.iifl.com/PaymentsCollectionUI/PaymentConfirmation.aspx',
  PAYMENTGATEWAYURL_1: 'https://hfcquickpayuat-a0gpgzdyb7asaqae.centralindia-01.azurewebsites.net/quick-pay/#/payments',
  ENCRYPT_PAYMENT_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
 MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA1t4Cjda+ZSpQfZFTz0Uv
 BZMqyL2dfASchlvPPMWRWaYmfsGm3Gx6vGB0HJ4FIr2z1WYXPoqQOdFbfH3n1N1D
 +4+rOr+G9nWohP0dQnv+Wf8MCXCK8atc7f90qpWtCPS0Zba0Lz7Kr/VsHgKIUbWs
 TtTe/jm5IrtgcNx263z5eBRfOQ8uM9J44EexqX9WTgxBHpdp9j/gyuw8tqMjRmpD
 ycXhSzlAh31cs3+Lm+S2OLRhQEYKskvEam2IiLrhXMmJOQUhrTGHElzoLJhWeprd
 PXDlR+ZFsv0lcjfNVVVpYhTUyYkyl4codhjmLYm43Wk4tsaoplJKawYzdIjdMqwR
 jnq5AGYEzwe+XxQyvNXvjcNr6VnmsO6CujfbopLg9Lv/XzEB9ws2b/YjGDVyDjm3
 2yBIOyCOxRmgsxrx5lRjQjTlHvRlHX4FNjNbJXmVC02OJDIsIaGtAsC8nw+Jyu+K
 1/SDLLscuBZe9Ml3gPImkOwBVxdzgkF+0M39VUPi4lv2pF76mcYAQvRL4kpU05Qm
 YQTkcTQN95W2J0DNDEAgg7norb4enAwO3RQ82W5Ecg7Y0mm0fXdRlH3lN05keibe
 YIens3SU1YVVnNJOCuPZQliu2XGnNWzUo2Q4JU9sepcR2ANUS7LYbMZphHCov+zD
 XFLpwrElZReBMjNWcgCl3okCAwEAAQ==
 -----END PUBLIC KEY-----`,

////////////// For Production ////////////////
PROD_API_URL: 'https://api.iiflonehome.com/api/',
PROD_SOCKETENDPOINT: 'https://api.iiflonehome.com',
PROD_REDIRECTURL:'https://api.iiflonehome.com/auction/bids',
PROD_FBAPPID: '590323375838229',
PROD_GOOGLECLIENTID: '632002254786-lfoejeohonsc4rgte87gl2ps6qmjouql.apps.googleusercontent.com',
PROD_SSLPINNING: "sha256/bMu9l9+NKsH+CxaWm1dgCbrQxfSiZ/N3M6//qhA8cIE=",
PROD_PAYMENTGATEWAYURL: 'https://smartapps.iifl.com/PaymentsCollectionUI/PaymentConfirmation.aspx',
PROD_PAYMENTGATEWAYURL_1: 'https://customerportal.iiflonehome.com/quick-pay/#/payments',
PROD_ENCRYPT_PAYMENT_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
   MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAru1CZm+DsQhPHeykc94L
   B5f4r2DUgKtlz/6O8Xqmy1RKgrOTAT5v1TJotHznF+lnY2TqtlvriuEu09wHZlXl
   Oh+7S+0T92/FGDL+Sx42HJFfjkGl+SR4jYA6KtYVcrMqHrBr2LnW7aYUvbR7PFp8
   FNdFciRY779yqxzNQAbdtla3pNqMlJiNivrstIYNQXXXDirZ72dEXxDDWw8I4JcH
   uqABJqF2xyJWRP0KaB5TxzK6j0Amw5nVgwqxSGdvZGZNcoUrYRFbpwxUWE131w6U
   vwyJCkX7ULUeraDF18HCQa5NN+lNUxlRZsrWnK+PvPUuDiF4XayT2XW3y5Bhfszm
   HwIDAQAB
   -----END PUBLIC KEY-----`
  }